import { render, staticRenderFns } from "./UserConnection.vue?vue&type=template&id=59e90ad1"
import script from "./UserConnection.vue?vue&type=script&lang=js"
export * from "./UserConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports